import { render, staticRenderFns } from "./apiVisit.vue?vue&type=template&id=b516120e&scoped=true&"
import script from "./apiVisit.vue?vue&type=script&lang=js&"
export * from "./apiVisit.vue?vue&type=script&lang=js&"
import style0 from "./apiVisit.vue?vue&type=style&index=0&id=b516120e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b516120e",
  null
  
)

export default component.exports